<template>
    <div class="page-body">
      <div class="container-fluid">
        <div class="edit-profile">
          <div class="row">
            <div class="col-12 col-xl-12">
              <div class="card">
                <div class="card-header">
                  <!-- Contenedor para el título "Perfil" con fondo negro -->
                  <div class="text-neutral-500 text-xl font-medium font-['Poppins'] leading-normal" >Perfil</div>
                  <div class="card-options">
                    <a class="card-options-collapse" href="#" data-bs-toggle="card-collapse">
                      <i class="fe fe-chevron-up"></i>
                    </a>
                    <a class="card-options-remove" href="#" data-bs-toggle="card-remove">
                      <i class="fe fe-x"></i>
                    </a>
                  </div>
                </div>
                <div>
                  <div class="row mb-2">
                      <div>
                        
                      </div>
                  </div>
                </div>
                <div class="card-body" style="margin-top: 20px;">
                  <form @submit.prevent="submitForm">
                    <div class="col-span-3 grid grid-cols-4 gap-4">
                      <!-- Primer campo en la fila -->
                      <div>
                        <label class="text-standard" for="name">Nombre</label>
                        <input v-model="form.name" type="text" id="name"  class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"  placeholder="Primer nombre" required >
                      </div>
                      <!-- Segundo campo en la fila -->
                      <div>
                        <label class="text-standard" for="last_name">Apellido Paterno</label>
                        <input v-model="form.last_name" type="text" id="last_name"  class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"  placeholder="Primer apellido" required >
                      </div>
                      <div>
                        <label class="text-standard" for="last_second_name">Apellido Materno</label>
                        <input v-model="form.last_second_name" type="text" id="last_second_name"  class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"  placeholder="Segundo apellido" required >
                      </div>
                      <!-- Tercer campo en la fila -->
                      <div>
                        <div class="text-standard">Email</div>
                        <input v-model="form.email" type="email" id="email"  class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"  placeholder="Ingrese su email" required >
                      </div>

                      <!-- Campo de teléfono con selector de país -->
                      <div>
                        <label class="text-standard" for="phone">Teléfono</label>
                        
                        <!-- Country code selector -->
                        <div class="custom-select-container mb-2">
                          <div class="selected-option" @click.stop="toggleDropdown">
                            <div v-if="selectedCountry" class="country-item">
                              <img 
                                v-if="getSelectedCountry && getSelectedCountry.flag" 
                                :src="getSelectedCountry.flag" 
                                :alt="`Bandera de ${getSelectedCountry.name}`" 
                                class="flag-img"
                              />
                              <span>{{ getSelectedCountry ? getSelectedCountry.name : '' }} ({{ selectedCountry }})</span>
                            </div>
                            <div v-else class="placeholder">Selecciona un país</div>
                            <div class="arrow-down"></div>
                          </div>

                          <!-- Dropdown options -->
                          <div class="dropdown-menu" v-if="isDropdownOpen">
                            <div 
                              v-for="country in filteredCountries" 
                              :key="country.dial_code"
                              class="country-option"
                              @click="selectCountry(country.dial_code)"
                            >
                              <img 
                                v-if="country.flag" 
                                :src="country.flag" 
                                :alt="`Bandera de ${country.name}`" 
                                class="flag-img"
                              />
                              <span>{{ country.name }} ({{ country.dial_code }})</span>
                            </div>
                          </div>
                        </div>

                        <!-- Phone number input -->
                        <input 
                          v-model="form.phone" 
                          type="tel" 
                          id="phone" 
                          :class="{
                            'self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-[\'Poppins\'] leading-normal': !phoneError,
                            'self-stretch px-4 py-[9px] bg-red-50 rounded-md border border-red-500 text-neutral-500 text-sm font-light font-[\'Poppins\'] leading-normal': phoneError
                          }"
                          placeholder="Ingresa tu número de teléfono" 
                          @input="onlyNumbers"
                          @blur="validatePhoneAndCheck"
                          maxlength="10"
                          required
                        />
                        <p v-if="phoneError" class="mt-1 text-sm font-medium text-red-600">{{ phoneError }}</p>
                      </div>

                      <!-- Segundo campo en la fila -->
                      <div class="flex flex-1 flex-col p-2 text-gray-900">
                            <label class="text-style-sm mb-1">Compañía</label>
                            <select  class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"  v-model="form.company_id" required>
                                <option value="0">Selecciona una compañía</option>
                                <option v-for="company in companies" :key="company.id" :value="company.id" required>
                                    {{ company.name }}
                                </option>
                            </select>
                      </div>
                    </div>
                    
                    <div class="row mb-2">
                      <div></div>
                    </div>
  
                    <div class="form-footer text-end">
                      <button class="custom-create-btn" :disabled="isSubmitting">
                        <span class="custom-create-btn-text">
                          {{ isSubmitting ? 'Guardando...' : 'Guardar' }}
                        </span>
                      </button>
                    </div>
                  </form>
                </div>
                <div v-if="successMessage" class="user-alert">
                  <div class="user-alert-content">
                    <div class="user-alert-text">
                      {{ successMessage }}
                    </div>
                  </div>
                  <div class="w-4 h-4 relative"></div>
                </div>
                <div v-if="errorMessage" class="user-alert-error">
                  <div class="user-alert-content">
                    <div class="user-alert-text">
                      {{ errorMessage }}
                    </div>
                  </div>
                  <div class="w-4 h-4 relative"></div>
                </div>
                <head>
                  <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap" rel="stylesheet">
                </head>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
    <script>
    import axios from 'axios';
    import { ref, computed, onMounted } from "vue";
    import { useStore } from 'vuex';
    import { useRouter } from "vue-router";
    
    export default {
      setup() {
        const store = useStore();
        const session = computed(() => store.getters.getUserSession);
        const successMessage = ref('');
        const errorMessage = ref('');
        const router = useRouter();
        
        // Country code selector variables
        const countryCodes = ref([]);
        const selectedCountry = ref("");
        const isDropdownOpen = ref(false);
        const phoneError = ref("");
        const isSubmitting = ref(false);

        // Form data
        const form = ref({
          email: '',
          name: '',
          last_name: '',
          last_second_name: '',
          phone: '',
          country_code: '',
          rol: '3',
          company_id: null,
        });

        let companies = ref([]);

        // Computed property para obtener el país seleccionado completo
        const getSelectedCountry = computed(() => {
          return countryCodes.value.find(country => country.dial_code === selectedCountry.value);
        });

        const filteredCountries = computed(() => {
          return [...countryCodes.value].sort((a, b) => a.name.localeCompare(b.name));
        });

        // Función para cerrar el dropdown cuando se hace clic fuera
        const closeDropdown = (e) => {
          const container = document.querySelector('.custom-select-container');
          if (container && !container.contains(e.target)) {
            isDropdownOpen.value = false;
          }
        };

        // Toggle dropdown
        const toggleDropdown = () => {
          isDropdownOpen.value = !isDropdownOpen.value;
        };

        // Select country
        const selectCountry = (dialCode) => {
          selectedCountry.value = dialCode;
          form.value.country_code = dialCode;
          isDropdownOpen.value = false;
        };

        // Only allow numbers in phone input
        const onlyNumbers = (event) => {
          form.value.phone = event.target.value.replace(/\D/g, '');
        };

        // Validate phone number format
        const validatePhone = () => {
          phoneError.value = '';
          
          if (!form.value.phone) {
            phoneError.value = 'Campo obligatorio';
            return false;
          }

          // Validar que el número tenga exactamente 10 dígitos
          const phoneRegex = /^\d{10}$/;
          if (!phoneRegex.test(form.value.phone)) {
            phoneError.value = 'El número debe tener exactamente 10 dígitos';
            return false;
          }

          return true;
        };

        // Check if phone exists
        const checkPhoneExists = async () => {
          if (!validatePhone()) {
            return { exists: false, error: true };
          }

          if (!selectedCountry.value) {
            phoneError.value = 'Debes seleccionar un país';
            return { exists: false, error: true };
          }

          const token = session.value.token_api;
          const completePhone = form.value.phone;
          const countryCode = selectedCountry.value;
          
          try {
            const response = await axios.get(
              `${process.env.VUE_APP_API_BASE_URL}/broker/check-phone-exists`,
              {
                params: {
                  phone: completePhone,
                  country_code: countryCode,
                },
                headers: {
                  Authorization: `Bearer ${token.trim()}`,
                },
              }
            );
            
            return { exists: response.data.exists, error: false, message: response.data.message };
          } catch (err) {
            console.error("Error al verificar el teléfono:", err);
            phoneError.value = err.response?.data?.message || "Error al verificar el teléfono.";
            return { exists: false, error: true, message: phoneError.value };
          }
        };

        // Validate phone and check existence
        const validatePhoneAndCheck = async () => {
          if (!validatePhone()) {
            return;
          }

          if (!selectedCountry.value) {
            phoneError.value = 'Debes seleccionar un país';
            return;
          }

          // Check if phone exists
          const { exists, error: checkError, message } = await checkPhoneExists();
          
          if (checkError) {
            return;
          }
          
          if (exists) {
            phoneError.value = message || "El número de teléfono ya está registrado. Por favor, utiliza otro número.";
          }
        };

        // Cargar códigos de país desde la API
        const loadCountryCodes = async () => {
          const token = session.value ? session.value.token_api : null;

          if (!token) {
            phoneError.value = "No se encontró la sesión del usuario. Vuelve a iniciar sesión.";
            return;
          }

          const url = `${process.env.VUE_APP_API_BASE_URL}/get-country-preferences`;
          const options = {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token.trim()}`,
            },
          };

          try {
            const response = await axios.get(url, options);
            countryCodes.value = response.data;
            console.log("Códigos de país activos cargados:", countryCodes.value);

            // Set default country (Mexico)
            if (countryCodes.value.length > 0) {
              const mexicoCountry = countryCodes.value.find(c => c.dial_code === '+52');
              
              if (mexicoCountry) {
                selectedCountry.value = '+52';
                form.value.country_code = '+52';
              } else {
                selectedCountry.value = countryCodes.value[0].dial_code;
                form.value.country_code = countryCodes.value[0].dial_code;
              }
            }
          } catch (err) {
            console.error("Error al cargar códigos de país:", err);
            phoneError.value = "No se pudieron cargar los códigos de país.";
          }
        };

        // Obtener compañías
        async function fetchCompanies() {
        try {
            let options = {
            headers: {
                'Authorization': `Bearer ${session.value.token_api}`
            }
            };
            const response = await axios.get(
            `${process.env.VUE_APP_API_BASE_URL}/companies`, options
            );

            if (response.status === 401) {
            store.dispatch('clearUserSession');
            }

            if (response.status === 200 && response.data?.resp?.companies) {
            companies.value = response.data.resp.companies;
            } else {
            console.error("Error en la respuesta de la API: estructura inesperada");
            }
        } catch (error) {
            console.error("Error al obtener las compañías:", error);
        }
        }
    
        onMounted(() => {
          fetchCompanies();
          loadCountryCodes();
          document.addEventListener('click', closeDropdown);
        });
        
        // Manejar el envío del formulario
        const submitForm = async () => {
          // Validar teléfono antes de enviar
          const { exists, error: checkError, message } = await checkPhoneExists();
          
          if (checkError) {
            return;
          }
          
          if (exists) {
            phoneError.value = message || "El número de teléfono ya está registrado. Por favor, utiliza otro número.";
            return;
          }

          if (!selectedCountry.value) {
            phoneError.value = 'Debes seleccionar un país';
            return;
          }

          isSubmitting.value = true;
          
          const token = session.value.token_api;

          if (!token) {
            console.error("No se ha encontrado el token de autenticación.");
            showToast('No se ha encontrado el token de autenticación', 'error');
            isSubmitting.value = false;
            return;
          }

          // Asegurar que el country_code esté en el form
          form.value.country_code = selectedCountry.value;
          
          axios.post(`${process.env.VUE_APP_API_BASE_URL}/broker/profile/create_new_account`, form.value, {
            headers: {
              'Authorization': `Bearer ${token}`
            } 
          })
          
          .then(response => {
            console.log('Usuario creado con éxito', response.data);
            showToast('Usuario creado con éxito', 'success');
            successMessage.value = 'Usuario creado con éxito';

            // Esperar 2 segundos antes de redireccionar
            setTimeout(() => {
              router.push({ name: "advisorList" });
            }, 2000);
          })
          
          .catch(error => {
            console.error('Error al crear usuario', error);

            if (error.response && error.response.status === 401) {
              console.error('No autorizado. Sesión cerrada.');
              showToast('Sesión expirada. Por favor, vuelve a iniciar sesión.', 'error');
              store.dispatch('clearUserSession');
            } else if (error.response && error.response.status === 409) {
              const errorMsg = error.response.data.message || "El número de teléfono ya está registrado.";
              phoneError.value = errorMsg;
              showToast(errorMsg, 'error');
            } else if (error.response && error.response.status === 422 && error.response.data.errors) {
              const errors = error.response.data.errors;
              for (const field in errors) {
                if (Object.prototype.hasOwnProperty.call(errors, field)) {
                  errors[field].forEach(msg => showToast(msg, 'error'));
                }
              }
            } else {
              // Manejo de errores generales
              const errorMsg = error.response?.data?.message || error.message || 'Ha ocurrido un error inesperado';
              showToast(errorMsg, 'error');
            }
          })
          .finally(() => {
            isSubmitting.value = false;
          });
        };

        const showToast = (message, type = 'success') => {
          console.log("Toast Message:", message);

          if (type === 'success') {
            successMessage.value = message;
            setTimeout(() => {
              successMessage.value = '';
            }, 3000);
          } else if (type === 'error') {
            errorMessage.value = message;
            setTimeout(() => {
              errorMessage.value = '';
            }, 3000);
          }
        };
        
        return {
          session,
          form,
          submitForm,
          showToast,
          companies,
          successMessage,
          errorMessage, 
          // Country code selector
          countryCodes,
          selectedCountry,
          isDropdownOpen,
          toggleDropdown,
          selectCountry,
          getSelectedCountry,
          filteredCountries,
          onlyNumbers,
          validatePhoneAndCheck,
          phoneError,
          isSubmitting,
        };
      }
    };
    </script>

    <style scoped>
      .mb-3 label {
        display: block;
        margin-bottom: 0.5rem;
      }
      .user-alert {
        background-color: #d4edda;
        border: 1px solid #c3e6cb;
        color: #155724;
        padding: 10px;
        border-radius: 5px;
        margin-top: 10px;
      }

      /* Country selector styles */
      .custom-select-container {
        position: relative;
        width: 100%;
        user-select: none;
      }

      .selected-option {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 8px 12px;
        border: 1px solid #dee2e6;
        border-radius: 6px;
        background-color: white;
        cursor: pointer;
        font-size: 14px;
        font-family: 'Poppins', sans-serif;
        font-weight: 300;
        color: #6c757d;
      }

      .country-item, .country-option {
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .placeholder {
        color: #6c757d;
      }

      .arrow-down {
        width: 0;
        height: 0;
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 5px solid #6c757d;
        margin-left: 8px;
      }

      .dropdown-menu {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        max-height: 200px;
        overflow-y: auto;
        background-color: white;
        border: 1px solid #dee2e6;
        border-top: none;
        border-radius: 0 0 6px 6px;
        z-index: 100;
      }

      .country-option {
        padding: 8px 12px;
        cursor: pointer;
        font-size: 14px;
        font-family: 'Poppins', sans-serif;
      }

      .country-option:hover {
        background-color: #f8f9fa;
      }

      .flag-img {
        width: 24px;
        height: auto;
        vertical-align: middle;
        border: 1px solid #ddd;
      }
    </style>